import { styled } from '@mui/material';

export const FormWrapper = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
`;
